import thumbnailWebsite from '../Blogs/Images/Thumbnail_Website.png';
import windedbreezen_sneakpeak from '../Blogs/Images/windedbreeze_sneak.png';
import discordbell_sneakpeak from '../Blogs/Images/discordbell_sneak.png';
const BLOGS = [
  {
    id: 1,
    title: 'SimpleMC - Official Website',
    slug: 'simplemc-official-website',
    category: 'Announcement',
    tags: ['new'],
    date: '2026-03-16',
    thumbnail: thumbnailWebsite,
    summary: 'Brand new website is live! Get all the latest news, updates and guides in one place.',
    body: [
      { type: 'heading', text: 'Website Features' },
      { type: 'paragraph', text: 'This website will continue to be **developed and improved** with new features rolling out regularly.' },
      { type: 'paragraph', text: '**Sneakpeaks** and exclusive previews will now be released here first, giving you early views to upcoming content!' },
      { type: 'paragraph', text: 'See you on the server. Join our **Discord** to stay up to date.' },
    ],
  },
  {
    id: 2,
    title: 'Sneakpeak: Winded Breeze',
    slug: 'sneakpeak-winded-breeze',
    category: 'Sneakpeak',
    subcategory: 'Mob',
    tags: ['Tier 2 Mob', 'new'],
    date: '2026-03-15',
    thumbnail: windedbreezen_sneakpeak,
    summary: 'A powerful breeze mob that deals massive knockback and wanders through the world.',
    body: [
      { type: 'paragraph', text: 'The **Winded Breeze** is a new Tier 2 mob for the season 1 release. This unpredictable breeze spawns wildly across the map and is very strong because of its knockback attacks.' },
      { type: 'heading', text: 'Winded Breeze' },
      {
        type: 'mob_card',
        name: 'Winded Breeze',
        tier: 'tier 2',
        emoji: '💨',
        type_label: 'Mob',
        damage: 'High Knockback',
        speed: 'Very Fast',
        hp: '250',
        abilitiescolor: '#1187cc',
        abilities: ['Tornade', 'Wind bursts', 'Wind shield '],
        lore: 'Blows through enemies one by one, pushing back everything in its way.',
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/windedbreeze_sneakpeak.mp4',
        poster: null,
        caption: 'Winded Breeze in action! Watch the full video to see all of its abilities and attacks.',
      },
    ],
  },
  {
    id: 5,
    title: 'Sneakpeak: Discord Bell',
    slug: 'sneakpeak-discord-bell',
    category: 'Sneakpeak',
    subcategory: 'Fun',
    tags: ['new'],
    date: '2026-03-17',
    thumbnail: discordbell_sneakpeak,
    summary: 'A fun new item that lets you ping or call nearby players > straight from your hotbar.',
    body: [
      {
        type: 'paragraph',
        text: 'The **Discord Bell** is a new fun item coming in Season 1. It lets you interact with nearby players in two ways a quick ping or a full incoming call, both playing sounds to everyone within **100 blocks**.',
      },
      { type: 'heading', text: 'How it works' },
      {
        type: 'paragraph',
        text: '**Right Click** > sends a Discord ping sound to all players within 100 blocks. Has a **3 second cooldown**.\n\n**Sneak + Right Click** > plays an incoming call sound to all nearby players. Has a **20 second cooldown**.',
      },
      { type: 'heading', text: 'Obtaining' },
      {
        type: 'paragraph',
        text: 'This item is a cosmetic which can be obtained ingame IF you have boosted our server! \n > Could also be found in **Supply drops**',
      },
      { type: 'heading', text: 'Details' },
      {
        type: 'paragraph',
        text: '> Radius: **100 blocks**',
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/DiscordBell_Sneakpeak.mp4',
        poster: null,
        caption: 'Ring the bell! and troll your friends with pings and calls.',
      },
    ],
  },
  {
    id: 6,
    title: 'Sneakpeak: Soul Warden',
    slug: 'sneakpeak-soul-warden',
    category: 'Sneakpeak',
    subcategory: 'Mob',
    tags: ['Tier 3 Mob', 'new'],
    date: '2026-03-18',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/SoulWarden/Sneakpeak_img_SoulWarden.png',
    summary: 'A terrifying Tier 3 wither type raid boss with two phases. Do not fight it alone.',
    body: [
      {
        type: 'paragraph',
        text: 'The **Soul Warden** is a new Tier 3 raid boss coming in Season 1. This wither type boss is still a **work in progress** but we wanted to give you an early look at what we\'re building. It\'s designed to be a challenge  we recommend bringing **2 to 4 players** before even thinking about fighting it.',
      },
      { type: 'heading', text: 'Two Phases' },
      {
        type: 'paragraph',
        text: 'The Soul Warden has two distinct phases that completely change how it fights.\n\n**Phase 1 (above 50% HP)** the boss stays ranged and bombards players with skull barrages, soul geysers, and minion summons. Spread out and watch the ground.\n\n**Phase 2 (below 50% HP)** it gains speed and switches to chaos. Expanding death rings, a pull-and-detonate attack, and more frequent minion spawns make this phase far more difficult.',
      },
      { type: 'heading', text: 'Soul Warden Preview Video' },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/SoulWarden/Sneakpeak_SoulWarden.mp4',
        poster: null,
      },
      { type: 'heading', text: 'Abilities' },
      {
        type: 'paragraph',
        text: `**Skull Barrage** > fires three projectiles of wither skulls at all nearby players.
        Stay spread out or multiple people get hit at once.

        **Soul Geyser** > marks spots on the ground that erupt after 2 seconds.
        Get off the marked location or get launched.

        **Soul Legion** > summons Soul Blazes and Soul Skeletons mid-fight.
        Clear them fast or they will overwhelm you.

        **Death Ring** > Phase 2 only. Expanding rings of soul fire pulse outward.
        Run away from the center immediately.

        **Pull & Detonate** > Phase 2 only. The boss pulls all nearby players toward it,
        then detonates. The closer you are, the harder the impact will be.`,
      },
      {
        type: 'paragraph',
        text: `At **10% HP** the Soul Warden enrages > 
        gaining Strength III and Speed II while summoning a final wave of minions. 
        Finish it quickly or the fight becomes nearly impossible.`,
      },
      {
        type: 'paragraph',
        text: '*This mob is still in development. Stats, abilities and drops are subject to change before release.*',
      },
    ],
  },
  {
    id: 7,
    title: 'Sneakpeak: Eternal Elytra',
    slug: 'sneakpeak-eternal-elytra',
    category: 'Sneakpeak',
    subcategory: 'Mechanic',
    tags: ['new'],
    date: '2026-03-19',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/EternalElytra/Sneakpeak_img_EternalElytra.png',
    summary: 'Elytras are back, but on our terms. Limited durability, self-repairing, no enchants.',
    body: [
      {
        type: 'paragraph',
        text: `Normal elytras break survival SMPs. Infinite flight kills exploration, shrinks the world and makes PvP a nightmare.
We still want travel to be fun though, so we made our own version.`,
      },
      { type: 'heading', text: 'How it works' },
      {
        type: 'paragraph',
        text: `The **Eternal Elytra** has a max durability of **20**. It repairs itself at +1 every 10 seconds while worn.
You get a solid glide between locations, land, wait a bit, and fly again.
It cannot be enchanted or repaired manually.`,
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/EternalElytra/EternalElytra_sneak.mp4',
        poster: null,
      },
      {
        type: 'paragraph',
        text: `*How to obtain will be revealed on Season 1 launch.*`,
      },
    ],
  },
  {
    id: 8,
    title: 'Sneakpeak: Upcoming Mob / Block drops',
    slug: 'sneakpeak-upcoming-mob-block-drops',
    category: 'Sneakpeak',
    subcategory: 'Drops',
    tags: ['new'],
    date: '2026-03-20',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/NewDrops/Sneakpeak_img_NewDrops.png',
    summary: 'Get a view of the new mob and block drops coming in Season 1.',
    body: [
      {
        type: 'paragraph',
        text: `Here's a sneak peek at some of the exciting mob and block drops that will be available in Season 1. These items will allow you to craft all our new gear, weapons, tools and more!`,
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/NewDrops/Sneakpeak_NewDrops.mp4',
        poster: null,
        muted: true,
      },
      {
        type: 'paragraph',
        text: `These items are still in development, but this video gives you a look at the direction we're heading with our new drops.`,
      },
    ],
  },
  {
    id: 9,
    title: 'Sneakpeak: Corrupted Evoker',
    slug: 'sneakpeak-corrupted-evoker',
    category: 'Sneakpeak',
    subcategory: 'Mob',
    tags: ['new'],
    date: '2026-03-21',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/CorruptedEvoker/Sneakpeak_CoruptedEvoker.png',
    summary: 'A Tier 3 corrupted evoker boss with two phases, soul drain, and an army of corrupted vex.',
    body: [
      {
        type: 'paragraph',
        text: `The **Corrupted Evoker** is a new Tier 3 boss coming in Season 1.
        Built on top of the vanilla evoker, this version has been affected by corruption >
        two phases, and a set of abilities that kills players who
        stay too close or spread out too far.`,
      },
      { type: 'heading', text: 'Two Phases' },
      {
        type: 'paragraph',
        text: `**Phase 1 (above 50% HP)** > the Corrupted Evoker stays mobile and fires projectiles,
        summons waves of Corrupted Vex, and drains HP from nearby players to heal itself.
        Every melee hit applies Weakness III that makes you unable to hit back, Wither and Blindness!.

        **Phase 2 (below 50% HP)** > it gains Speed and Strength, immediately summons 6 Corrupted Vex,
        and at 35% HP activates a **Dark Shield** > becoming nearly invincible for a few seconds
        before releasing a burst that launches nearby players away.`,
      },
      { type: 'heading', text: 'Corrupted Evoker' },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/CorruptedEvoker/Sneakpeak_CorruptedVindicator.mp4',
        poster: null,
      },
    ],
  },
  {
    id: 10,
    title: 'Sneakpeak: Pointisland',
    slug: 'sneakpeak-pointisland',
    category: 'Sneakpeak',
    subcategory: 'POI',
    tags: ['new'],
    date: '2026-03-22',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/PointIsland/PointIsland.png',
    summary: 'A mysterious floating island drifting high above the world. What is up there?',
    body: [
      {
        type: 'paragraph',
        text: `**Pointisland** is a floating island POI coming in Season 1.
Drifting high above the overworld, it is visible from a distance but reaching it is a challenge on its own.
What is up there is yours to discover.`,
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/PointIsland/sneakpeak-pointisland_v5SZNwFp.mp4',
        poster: null,
      },
      { type: 'heading', text: 'What we can tell you' },
      {
        type: 'paragraph',
        text: `Pointisland is not just decoration > it has a purpose.
Expect unique loot, a reason to make the climb, and something worth fighting over once you get up there.
More details will drop closer to Season 1 launch.`,
      },
      {
        type: 'paragraph',
        text: `*Pointisland is still being built. Screenshots and full details coming soon.*`,
      },
    ],
  },

  {
    id: 11,
    title: 'Sneakpeak: Crimson Reaper',
    slug: 'sneakpeak-crimson-reaper',
    category: 'Sneakpeak',
    subcategory: 'Weapon',
    tags: ['new'],
    date: '2026-03-22',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/Crimson%20Reaper/Crimson_Reaper.png',
    summary: 'A legendary greatsword that grows stronger with every kill. Stack charges, release carnage.',
    body: [
      {
        type: 'paragraph',
        text: `The **Crimson Reaper** is a Legendary netherite greatsword with one goal > reward aggressive play.
Kill mobs to stack Blood Charges, then unleash them all in a single blood explosion.
The more you kill, the harder it hits.`,
      },
      { type: 'heading', text: 'Crimson Reaper' },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/Crimson%20Reaper/Minecraft%202026.03.23%20-%2020.49.51.07.DVR%20-%20Trim.mp4',
        poster: null,
      },
      { type: 'heading', text: 'Abilities' },
      {
        type: 'paragraph',
        text: `**Blood Price** > every mob kill stores 1 Blood Charge up to a max of 5.
Each charge is shown on the item. The more you fight, the more powerful the next ability becomes.

**Reaper's Wrath** > consume all stored charges and release a blood explosion dealing 5 damage per charge
to all nearby enemies. At max charges that is 25 damage in a 6 block radius. 10 second cooldown, requires at least 1 charge.

**Cleave** > every hit on a mob deals an additional 3 bonus damage. 2 second cooldown per proc.`,
      },
      {
        type: 'paragraph',
        text: `*The Crimson Reaper is a rare drop > exact source will be revealed on launch.*`,
      },
    ],
  },
  {
    id: 12,
    title: 'Sneakpeak: Supply Drop Item',
    slug: 'sneakpeak-supply-drop-item',
    category: 'Sneakpeak',
    subcategory: 'Mechanic',
    tags: ['new'],
    date: '2026-03-22',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/SupplyDrop/SupplyDrop_sneak.png',
    summary: 'Call in a supply drop anywhere in the world. Five rarities, one item, one use.',
    body: [
      {
        type: 'paragraph',
        text: `The **Supply Drop** item lets you call in a crate from anywhere in the world.
Right click it and a drop is randomly selected from five rarities and lands at your location.
The item has one use > make it count.`,
      },
      { type: 'heading', text: 'Rarities' },
      {
        type: 'paragraph',
        text: `The rarity is randomly selected when you use the item:

**Common** > 30% chance
**Rare** > 25% chance
**Epic** > 20% chance
**Legendary** > 15% chance
**Mythic** > 10% chance

Higher rarity means better loot. Mythic drops are extremely rare and contain the best items in the game.`,
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/SupplyDrop/SupplyDrop_Sneak.mp4',
        poster: null,
      },
      {
        type: 'paragraph',
        text: `*How to obtain Supply Drop items will be revealed closer to Season 1 launch.*`,
      },
    ],
  },
  {
    id: 13,
    title: 'Website Update — April 2026',
    slug: 'website-update-april-2026',
    category: 'Update',
    tags: ['change', 'new'],
    date: '2026-04-04',
    thumbnail: thumbnailWebsite,
    summary: 'New giveaway system, entries modal with win chances, blog views, and refreshed page heroes.',
    body: [
      {
        type: 'paragraph',
        text: 'We\'ve shipped a number of **website improvements** this week. Here\'s a quick rundown of everything that changed.',
      },
      { type: 'heading', text: 'New Giveaway' },
      {
        type: 'paragraph',
        text: 'A brand new **invite-based giveaway** is now live on the Giveaways page. Invite friends to the Discord to earn tickets — the more invites you have, the higher your chance of winning. Maximum 6 tickets per person.',
      },
      { type: 'heading', text: 'Entries Modal' },
      {
        type: 'paragraph',
        text: 'You can now click **"View all entries"** on any giveaway (current or past) to open a detailed modal showing every participant\'s **Minecraft head**, name, invite count, and their exact **win chance %**. Winners are highlighted in gold, silver, and bronze.',
      },
      { type: 'heading', text: 'Blog Views Instead of Likes' },
      {
        type: 'paragraph',
        text: 'Blog post **likes have been removed** and replaced with a **view counter**. Every time someone opens a blog post the view count goes up. You can see the count on each card and inside the post itself.',
      },
      { type: 'heading', text: 'Page Hero Refresh' },
      {
        type: 'paragraph',
        text: 'The **Ranks** page now has the same video hero style as Blogs and Giveaways — background video, overlay gradient, eyebrow label, and a title with an accent highlight. All page heroes are now consistent across the site.',
      },
    ],
  },
  {
    id: 14,
    title: 'Sneakpeak: Waystone Compass',
    slug: 'sneakpeak-waystone-compass',
    category: 'Sneakpeak',
    subcategory: 'Mechanic',
    tags: ['new'],
    date: '2026-04-09',
    thumbnail: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/WayStoneCompass/Schermafbeelding%202026-04-09%20165633.png',
    summary: 'A glowing compass that lets you mark a location, leave a particle trail, and recall back — with a few catches.',
    body: [
      {
        type: 'paragraph',
        text: `The **Waystone Compass** is a new utility item coming in Season 1.
It gives you a personal waypoint system straight from your hotbar.
Mark a spot, come back to it later — but it's not without limits.`,
      },
      { type: 'heading', text: 'How it works' },
      {
        type: 'paragraph',
        text: `**Right Click** > sets a waypoint at your current location. Your coordinates are saved and shown in the item lore so you always know where it points. **20 second cooldown.**

**Sneak + Right Click** > teleports you back to your saved waypoint. A short delay before the teleport gives you a moment to prepare, and particles fire on both ends when you land. **120 second cooldown.** Requires a waypoint to be set.

**Sneak + Left Click** > clears your saved waypoint immediately. No cooldown.`,
      },
      {
        type: 'video_mp4',
        src: 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Sneakpeaks/WayStoneCompass/0409.mp4',
        poster: null,
      },
      { type: 'heading', text: 'Limitations' },
      {
        type: 'paragraph',
        text: `The Waystone Compass is not a free teleport. Two things will **automatically remove your waypoint**:

**Distance** > if you move more than **100 blocks** away from your waypoint, it is cleared and you get a warning. You have to be nearby to use the recall.

**World change** > leaving the world your waypoint was set in clears it instantly. You cannot recall across dimensions.

Both of these are intentional. The compass is a short-range anchor, not a cross-map fast travel.`,
      }
    ],
  },
];

export default BLOGS;